import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Page from '../../../components/Page/Page';
import { HomeProvider } from '../../context/homeContext';

import getAllHomePageSettingsQuery from './getAllHomePageSettings.graphql';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';
import s from './Legal.css';

const Legal = ({ data, containerClass }) => {
  const currentLocale = useSelector((state) => state?.intl?.locale);

  const { data: homeSettingsData, loading: loadingHomeSettings } = useQueryResponse({
    query: getAllHomePageSettingsQuery
  });

  const homeSettings = useMemo(() => {
    const settings = {};
    if (homeSettingsData?.getAllHomePageSettings?.homePageData) {
      homeSettingsData.getAllHomePageSettings.homePageData.forEach((item) => {
        settings[item.name] = item.value;
      });
    }
    return settings;
  }, [homeSettingsData]);

  const staticPage = data?.getEditStaticPage?.result;
  const pageBanner = staticPage?.pageBanner;

  const dynamicStaticContent = getDynamicTitleByLocale({
    dynamicHomePageSettings: staticPage?.dynamicStaticContent,
    locale: currentLocale,
  });

  const content = dynamicStaticContent?.[0]?.content || staticPage?.content;

  if (loadingHomeSettings) {
    return null;
  }

  return (
    <HomeProvider value={homeSettings}>
      <div className={containerClass}>
        <div className={s.homeBanner} />
        <Page html={content} pageBanner={pageBanner} />
      </div>
    </HomeProvider>
  );
};

export default withStyles(s)(Legal);
